import {request} from "./requests";
import {Entity} from "./converter";

/**
 * TODO, cache the entity there?
 * @param {String} shortcode
 * @return Promise
 */
export function getEntity(shortcode) {
    return request({
        url: `/e/${shortcode}`,
        method: 'get'
    }).then((e)=>{
        console.log('getEntity', e)
        return new Promise((resolve, reject)=>{
            resolve(Entity.convertEntity(e));
        })
    });
}

/**
 * @param {Array<String>} shortcodes
 * @return {Promise<unknown>}
 */
export async function getEntities(shortcodes) {
    let entities = await request({
        url: `/e/list`,
        method: 'post',
        data: JSON.stringify(shortcodes),
        // 必须设置 content-type 为 application/json，否则服务器端不会直接解析为 Array，已经添加到 requests.js 中
        // headers: {'Content-Type': 'application/json'}
    });
    return Entity.convertEntities(entities);
}

export async function saveViewHis(shortcode){
    await request({
        url: `/e/viewhis`,
        method: 'post',
        data: {shortcode: shortcode}
    })
}





// WEBPACK FOOTER //
// ./src/data/entity.js